var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datatable',{attrs:{"modelData":_vm.dtData}})
}
var staticRenderFns = []

export { render, staticRenderFns }